import styles from './ContentWrapper.module.css';

const ContentWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <div className={`flex-col ${styles.wrapper}`}>{children}</div>
);

export default ContentWrapper;
